
export default {
  name: 'Affix',
  emits: ['initScroll'],
  data() {
    return {
      loading: false,
      contentShow: false,
      form: {
        request: '',
        name: '',
        tel: ''
      },
      rules: {
        request: [
          { required: true, message: '需求不能为空', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '姓名不能为空', trigger: 'blur' }
        ],
        tel: [
          { required: true, message: '电话不能为空', trigger: 'blur' },
          { validator: (rule, value, callback) => {
            if (!/(^0\d{2,3}-?\d{7,8})|(^1\d{10})$/.test(value)) {
              callback(new Error('请输入正确的电话'))
            } else {
              callback()
            }
          }, trigger: 'blur'}
        ]
      }
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    submitForm() {
      this.$refs['contactForm'].validate((valid) => {
        if (valid) {
          this.handleSubmit()
        }
      })
    },
    handleSubmit() {
      this.loading = true
      let obj = this.form
      this.$http.post('/ow/data/saveFeedback', obj, (res) => {
        if (res.data.success) {
          this.$message.success('已收到您的需求，我们将尽快与您联系。')
          this.closeForm()
        }
        this.$nextTick(() => {
          this.loading = false
        })
      }, () => {
        this.loading = false
      })
    },
    closeForm() {
      this.$refs['contactForm'].resetFields()
      this.contentShow = false
    }
  },
  components: {}
}
